import { render, staticRenderFns } from "./AllocateEsims.vue?vue&type=template&id=7ab0bcde&"
import script from "./AllocateEsims.vue?vue&type=script&lang=js&"
export * from "./AllocateEsims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports